export default {
    errors: {
        wrongCard: 'Δυστυχώς ο κωδικός AB Plus δεν αναγνωρίζεται από τον ειδικό σαρωτή. Παρακαλούμε πατήστε το πλήκτρο «Επιστροφή» και προσπαθήστε ξανά',
        printerError: 'Πρόβλημα με τον εκτυπωτή',
        wrongCode: 'Ο κωδικός προσφοράς δεν είναι έγκυρος!',
        bannedCard: ['Ουπς, αυτή η κάρτα είναι άκυρη!', 'Χρησιμοποίησε μία ενεργή για να προχωρήσεις. Στην περίπτωση που δεν έχεις, απόκτησε μία νέα δημιουργώντας λογαριασμό στο', 'ab.gr', 'ή κατεβάζοντας το', 'AB app!']
    },
    printerStatus: {
        printingMessage: 'Τα κουπόνια σου τυπώνονται',
        printedMessageOne: 'Τα κoυπόνια σου',
        printedMessageTwo: 'τυπώθηκαν με επιτυχία!',
        useWithCard: 'Χρησιμοποίησε το στο ταμείο με την κάρτα σου',
        AB: 'AB Plus!',
        oneStep: 'Είσαι ένα βήμα',
        closerToNext: 'πιο κοντά στην επόμενη',
        toCoupons: 'στα κουπόνια'
    },
    editProfile: {
        header: 'Φτιάξε τον χαρακτήρα σου',
        avatarName: 'Ονόμασε το χαρακτήρα σου',
        consentMessage: 'Θέλεις να εμφανίζεται το όνομα στην λίστα κατάταξης;',
        phoneNumberHint: 'Βάλε το κινητό σου για να λαμβάνεις ψηφιακά το κουπόνι από το κάθε παιχνίδι',
        selectAvatar: 'Διάλεξε τον χαρακτήρα σου',
        onlyUpperGreek: 'Δέν επιτρέπονται σύμβολα και αριθμοί',
        fillForm: 'Ονόμασε το χαρακτήρα σου',
        saveCredentials: 'Αποθήκευση',
        tooManyCardsError: 'Έχεις καταχωρήσει το κινητό σου σε παραπάνω από μία κάρτα AB Plus. H διαδικασία δεν μπορεί να ολοκληρωθεί.',
        wrongPhoneError: 'Το κινητό που πληκτρολόγησες δεν είναι έγκυρο',
        phoneRequired: 'Κινητό: Υποχρεωτικό πεδίο',
        saved: 'Τα στοιχεία σου ενημερώθηκαν',
        refresh: 'Η κατάταξη ενημερώνεται κάθε 2 ώρες'
    },
    gameInfo: {
        header: ['Καλωσόρισες', 'στην ενότητα παιχνιδιών AB Plus!'],
        infoMessage: ['Σε αυτήν την ενότητα μπορείς να παίζεις και να κερδίζεις επιπλέον πόντους AB Plus!', ' Φτιάξε τον ψηφιακό σου χαρακτήρα για να βλέπεις το ιστορικό και την κατάταξη σου.']
    },
    gameList: {
        mainText: 'Πάτησε πάνω στα παιχνίδια, παίξε και κέρδισε!',
        availableTill: ' Διαθέσιμο έως',
        playAgain: ['ΠΑΙΞΕ ΞΑΝΑ', 'Χωρίς να κερδίσεις πόντους'],
        noGamesMessage: 'Σύντομα κοντά σου με περισσότερα παιχνίδια',
        bannerText: 'Τώρα κερδίζεις πόντους από παιχνίδια αυτόματα, χωρίς barcode!'
    },
    employeeAffinity: {
        header: 'Παροχές Εργαζόμενων ΑΒ',
        headerBottom: 'Χρειάζεται η συναίνεσή σου!',
        firstText: 'Με το παρόν σε ενημερώνουμε ότι θα συνδεθεί ο Αριθμός Μητρώου Εργαζόμενου με τον αριθμό της κάρτας που έχεις καταχωρήσει, με σκοπό τη στιγμιαία επιβράβευσή σου, αλλά και τη συμμετοχή σου στο εταιρικό πρόγραμμα πιστότητας AB Plus προς τους εργαζόμενους.',
        secondText: 'Για την κάρτα που καταχωρείς τεκμαίρεται ότι είσαι νόμιμος κάτοχος και κομιστής αυτής και οποιαδήποτε ενημέρωση ή επιβράβευση στο πλαίσιο του εταιρικού προγράμματος πιστότητας θα σχετίζεται με τη συγκεκριμένη κάρτα, χωρίς η ΑΒ να φέρει οποιαδήποτε περαιτέρω ευθύνη. Για οποιαδήποτε αλλαγή έχεις την ευθύνη να ενημερώσεις τη Διεύθυνση Ανθρώπινου Δυναμικού.',
        consentText: 'Επιθυμώ να λαμβάνω εταιρικές προωθητικές επικοινωνίες, ενημερώσεις και προσφορές της ΑΒ προς τους εργαζομένους της μέσω κινητού.',
        buttonText: 'Ενημερώθηκα'
    },
    gamesHistory: {
        pointsText: ['Πόντοι', 'που έχεις κερδίσει'],
        play: ['ΠΑΙΞΕ', 'ΤΩΡΑ'],
        playAgain: ['ΠΑΙΞΕ', 'ΞΑΝΑ'],
        availableGames: ['Παιχνίδια', 'που σε περιμένουν'],
        completedGames: ['Παιχνίδια', 'που έχεις παίξει'],
        touchPoint: 'AB MPASS Stage',
        webPoint: 'Online',
        noGamesYet: ['Έχεις παίξει όλα τα διαθέσιμα παιχνίδια!', 'Μείνε συντονισμένος διότι σύντομα θα διατεθούν νέα!'],
        points: 'ΠΟΝΤΟΙ'
    },
    gamesLeaderBoard: {
        ranking: 'Κατάταξη',
        rankingLabel: 'Δες τη θέση σου ανάμεσα σε %{totalPlayers} παίκτες',
        refresh: 'H κατάταξη ενημερώνεται κάθε 2 ώρες',
        yourPosition: 'Η θέση σου',
        games: ['ΠΑΙΧΝΙΔΙΑ', 'ΠΑΙΧΝΙΔΙ']
    },
    gameTile: {
        availableTill: ' Διαθέσιμο έως',
        pointsGain: ['Κέρδισε έως', 'πόντους'],
        play: ['ΚΕΡΔΙΣΕ', 'ΠΟΝΤΟΥΣ'],
        playAgain: ['ΠΑΙΞΕ', 'ΞΑΝΑ']
    },
    gameFooterBar: {
        games: 'Παιχνίδια',
        myProfile: 'Ο χαρακτήρας μου',
        history: 'Ιστορικό',
        ranking: 'Κατάταξη',
        invites: 'Προσκλήσεις',
        info: 'Πληροφορίες',
        menu: 'Μενού'
    },
    gameTopBar: {
        cardCode: 'ΚΩΔΙΚΟΣ ΚΑΡΤΑΣ',
        points: ['ΠΟΝΤΟΙ ΑΠΟ', 'ΠΑΙΧΝΙΔΙΑ'],
        fromGames: 'ΑΠΟ ΠΑΙΧΝΙΔΙΑ',
        from: 'ΑΠΟ',
        gamesUP: 'ΠΑΙΧΝΙΔΙΑ',
        gain: 'ΟΦΕΛΟΣ',
        position: 'ΘΕΣΗ',
        available: 'Διαθέσιμα',
        games: 'Παιχνίδια',
        bannerText: ['ΤΩΡΑ ΤΟ ΟΦΕΛΟΣ ΣΟΥ ΕΝΕΡΓΟΠΟΙΕΙΤΑΙ', 'ΑΥΤΟΜΑΤΑ', 'ΣΤΗΝ ΚΑΡΤΑ ΣΟΥ!']
    },
    menu: {
        home: 'Αρχική',
        exit: 'Έξοδος',
        profile: 'Προφίλ',
        ranking: 'Κατάταξη',
        history: 'Ιστορικό',
        info: 'Πληροφορίες',
        invites: 'Προσκλήσεις',
        games: 'Παιχνίδια',
        character: 'Ο χαρακτήρας μου',
        logout: 'Αποσύνδεση'
    },
    webCoupons: {
        alreadyRedeemed: 'Έχεις ενεργοποιήσει:',
        pressButton: 'Ενεργοποίηση',
        activatedButton: 'Eνεργό από',
        cashRedemption: 'Τελευταία Εξαργύρωση',
        selectAll: 'Ενεργοποίηση όλων',
        shop: 'Κατάστημα',
        eshop: 'AB Eshop',
        franchise: 'AB Franchise',
        eshopText: ['ΗΛΕΚΤΡΟΝΙΚΗ', 'ΠΑΡΑΓΓΕΛΙΑ'],
        disclaimer: ['Κάθε ψηφιακό κουπόνι ισχύει για μία φορά σε μία συναλλαγή με χρήση της AB Plus.', 'Κάνοντας τις αγορές σου βάσει των προϋποθέσεων που αναφέρονται στο κάθε κουπόνι που ενεργοποίησες, οι πόντοι θα πιστωθούν αυτόματα στην κάρτα σου.', '* Η ενεργοποίηση κουπονιών θα πρέπει να γίνει τουλάχιστον 15\' πριν την αγορά.', '* Ενδέχεται στις προσφορές κουπονιών να μη συμμετέχουν κάποια προϊόντα που διατίθενται αποκλειστικά σε καταστήματα συνεργατών AB (AB Shop & Go & AB Food Market).', '* Οι προσφορές κουπονιών ισχύουν για το σύνολο των καταστημάτων που λειτουργούν υπό τα σήματα της ΑΒ με εξαίρεση το κατάστημα της εταιρείας εντός του Αεροδρομίου «Ελ. Βενιζέλος».']
    },
    loginModal: {
        typeCode: ['Πληκτρολόγησε', 'τον κωδικό', 'AB Plus', 'σου!'],
        codeInfo: 'Ο κωδικός βρίσκεται στο πίσω μέρος της κάρτας',
        here: 'εδώ!',
        in: 'Είσοδος',
        devIn: 'Developer Login',
        tryAgain: 'Λανθασμένα στοιχεία προσπάθησε ξανά',
        connectionFailure: 'Παρουσιάστηκε κάποιο σφάλμα, παρακαλώ προσπαθήστε αργότερα'
    },
    terms: {
        one: '1.Η ανώνυμη εταιρεία «ΑΛΦΑ – ΒΗΤΑ ΒΑΣΙΛΟΠΟΥΛΟΣ ΑΕ» (εφεξής η «ΑΒ») που εδρεύει στο Γέρακα Αττικής (Λ. Σπάτων 81) παρέχει στους κατόχους της κάρτας πιστότητας AB PLUS τη δυνατότητα να εκτυπώνουν κουπόνια προσφοράς πόντων μέσω ειδικών kiosks που έχει τοποθετήσει σε καταστήματά της.',
        two: '2.Η ΑΒ αποστέλλει ενημέρωση μέσω σύντομων μηνυμάτων (SMS) για τη λήψη εκπτωτικών κουπονιών μέσω των kiosks στους κατόχους της κάρτας πιστότητας AB PLUS που το κινητό τους τηλέφωνο είναι καταχωρημένο στη βάση της ΑΒ κι εφόσον δεν έχουν εκφράσει την αντίρρησή τους στη λήψη τέτοιου είδους μηνυμάτων. Σε περίπτωση που κάποιος από τους κατόχους κάρτας πιστότητας AB PLUS επιθυμεί να δηλώσει ότι επιθυμεί να λαμβάνει ενημερώσεις μέσω SMS μπορεί να το κάνει καλώντας στην ανοιχτή γραμμή επικοινωνίας της ΑΒ στο 18202 (χρέωση βάσει ισχύοντα τιμοκαταλόγου του εκάστοτε παρόχου). Επιπλέον σε περίπτωση που κάποιος κάτοχος κάρτας πιστότητας AB PLUS επιθυμεί να δηλώσει το κινητό του τηλέφωνο για τη λήψη ενημερώσεων μέσω SMS μπορεί να το κάνει και στα kiosks συμπληρώνοντας τον αριθμό της κάρτας πιστότητας AB PLUS, τον αριθμό κινητού τηλεφώνου και τον επιβεβαιωτικό κωδικό που θα λάβει μέσω SMS στο κινητό του τηλέφωνο. Με την ως άνω δήλωση ο κάτοχος του κινητού τηλεφώνου συναινεί στη λήψη ενημερώσεων μέσω SMS από την ΑΒ και δύναται να δηλώσει τυχόν αντίρρησή του καλώντας στην ανοιχτή γραμμή επικοινωνίας της ΑΒ στο 18202 (χρέωση βάσει ισχύοντα τιμοκαταλόγου του εκάστοτε παρόχου). ',
        three: {
            main: '3.Για την εκτύπωση και λήψη των κουπονιών προσφοράς πόντων παρακαλούμε ακολουθείστε τις οδηγίες που σας δίδονται στα kiosks. Ως προς την εκτύπωση, εμφάνιση και εξαργύρωση των κουπονιών ισχύουν τα ακόλουθα:',
            one: 'i. Επιτρέπεται μία συμμετοχή ανά κάρτα πιστότητας, ανά κινητό τηλέφωνο και  ανά ενέργεια.',
            two: 'ii. Κάθε κουπόνι μπορεί να εκτυπωθεί μία φορά και η απόκτηση πόντων γίνεται μόνο με την αγορά του προϊόντος που είναι σε προσφορά. Σε κάθε συναλλαγή μπορεί να χρησιμοποιηθεί μόνο ένα κουπόνι ανά προϊόν. Η ΑB δύναται να αρνηθεί τη χρήση επιπλέον κουπονιού ανά ίδια κατηγορία προϊόντων ή προϊόντος. Διευκρινίζεται ότι τα κουπόνια δεν εξαργυρώνονται με καταβολή χρημάτων.',
            three: 'iii. Κάθε κουπόνι μπορεί να εμφανιστεί μέχρι την ημερομηνία λήξης αυτού, όπως αυτή αναγράφεται στο κάθε κουπόνι.',
            for: 'iv. Κάθε κουπόνι μπορεί να εμφανιστεί μέχρι την ημερομηνία λήξης αυτού, όπως αυτή αναγράφεται στο κάθε κουπόνι.',
            five: 'v. Διευκρινίζεται ότι το συγκεκριμένο πρόγραμμα αποτελεί οικειοθελή προσφορά της ΑΒ προς τους πελάτες/κατόχους της κάρτας πιστότητας ΑΒ PLUS και μπορεί ανά πάσα στιγμή να τροποποιηθεί με παράλληλη τροποποίηση των παρόντων όρων και χωρίς οποιαδήποτε ευθύνη της ΑΒ έναντι των πελατών της.'
        }
    },
    termsInfo: {
        infoMessage: 'Για να συνεχίσετε τη διαδικασία θα πρέπει να συμφωνήσετε με τους Όρους Χρήσης.'
    },
    affinityOfferList: {
        headerTextOne: 'Επίλεξε την AFFINITY προσφορά που θέλεις',
        headerTextTwo: 'και εκτύπωσε τα κουπόνια σου'
    },
    couponList: {
        selectedCouponsPartOne: 'Έχεις επιλέξει κουπόνια ',
        selectedCouponsPartTwo: ' πόντων',
        remainingCouponsPartOne: 'Απομένουν ακόμα ',
        remainingCouponsPartTwo: 'πόντοι',
        allCouponsPrinted: 'Έχεις εκτυπώσει όλα τα κουπόνια σου!',
        bottomTextOne: 'Επίλεξε τα κουπόνια που σου αρέσουν',
        bottomTextTwo: 'και πάτησε Εκτύπωση',
        bottomTextSmall: 'Όσα κουπόνια δεν επιλέξεις θα παραμείνουνε διαθέσιμα μέχρι τη λήξη της προσφοράς',
        activeCouponText: 'ΕΝΕΡΓΗ ΑΠΟ'
    },
    submit: {
        submit: 'ΥΠΟΒΟΛΗ'
    },
    goBack: {
        goBack: 'Επιστροφή'
    },
    landing: {
        myCardOne: 'Η δική μου',
        myCardTwo: 'AB Plus κάρτα',
        scaning: 'Σκάναρε την κάρτα σου',
        haveCardOne: 'Έχεις κάρτα',
        haveCardTwo: 'AB Plus;',
        register: 'Κάνε την εγγραφή σου'
    },
    mainMenu: {
        myOffersOne: 'Οι δικές μου',
        myOffersTwo: 'προσφορές',
        noOffers: 'Δεν υπάρχουν αυτή τη στιγμή προσφορές'
    },
    offersList: {
        headerOne: 'Επίλεξε την προσφορά που θέλεις',
        headerTwo: 'και εκτύπωσε τα κουπόνια σου'
    },
    offer: {
        mainMessageOne: 'Τα κουπόνια μου',
        mainMessageTwo: 'Εκτύπωσε τα κουπόνια σου ή',
        mainMessageThree: 'κάνε δήλωση συμμετοχής',
        mainMessageFour: 'για να κερδίζεις κάθε φορά'
    },
    offerTermsInfo: {
        update: 'Ενημέρωση',
        pressButton: 'Πατήστε το κουμπί ',
        terms: 'Όροι Χρήσης',
        toGo: 'για να μεταβείτε στους όρους',
        orPressButton: 'ή πατήστε το κουμπί',
        back: 'Επιστροφή',
        toCancell: 'για να ακυρώσετε τη διαδικασία.'
    },
    offerTerms: {
        termsToAgree: 'Όροι πρός αποδοχή',
        disagree: 'Διαφωνώ',
        agreed: 'Συμφωνώ'
    },
    scanCard: {
        tittle: {
            one: 'Σκάναρε την',
            two: 'AB Plus κάρτα σου',
            three: 'στο σαρωτή που βρίσκεται κάτω δεξιά'
        },
        cancel: 'Ακύρωση',
        fakeScan: 'Fake scan for Development purpose'
    },
    profileTopBar: {
        cancel: 'Ακύρωση'
    },
    topBar: {
        cardCode: 'ΚΩΔΙΚΟΣ ΚΑΡΤΑΣ'
    },
    comboResults: {
        cashIn: 'Εξαργύρωσε',
        yourCoupon: 'το κουπόνι σου'
    },
    couponHeader: {
        header: 'ΑΝΑΚΑΛΥΨΕ ΤΑ ΝΕΑ ΚΟΥΠΟΝΙΑ AB PLUS!',
        firstInstruction: ['ΕΝΕΡΓΟΠΟΙΗΣΕ ΤΑ ΚΟΥΠΟΝΙΑ', 'με ένα μόνο κλικ* !'],
        secondInstruction: ['ΑΓΟΡΑΣΕ ΤΑ ΠΡΟΪΟΝΤΑ', 'από τα καταστήματα μας ή το AB eshop με την AB Plus'],
        thirdInstruction: ['ΚΕΡΔΙΣΕ ΠΟΝΤΟΥΣ', 'ΑB Plus'],
        validUntil: 'Ισχύουν έως',
        from: 'από',
        active: 'ενεργοποιημένα'
    },
    comboCoupon: {
        create: 'Φτιάξε το',
        combo: 'combo σου',
        win: '& κέρδισε',
        points: 'πόντους!'
    },
    carouselFlip: {
        couponPrinted: 'Το κουπόνι εκτυπώθηκε στις',
        couponForCashIn: 'Κουπόνι για εξαργύρωση στα ταμεία των καταστημάτων',
        eachCouponOneTime: ' Το κάθε κουπόνι ισχύει για μία φορά, σε μία συναλλαγή.'
    },
    coupon: {
        copyright: 'Powered by MPASS'
    },
    expiredOrInvalidView: {
        message: ['ΑΥΤΗ ΤΗΝ ΣΤΙΓΜΗ ΔΕΝ ΥΠΑΡΧΟΥΝ ΔΙΑΘΕΣΙΜΑ ΚΟΥΠΟΝΙΑ',
            'ΣΥΝΤΟΜΑ ΚΟΝΤΑ ΣΟΥ ΜΕ ΝΕΕΣ ΠΡΟΣΦΟΡΕΣ!'
        ]
    },
    canceldCardView: {
        message: ['Αυτή η κάρτα είναι άκυρη!',
            'Μπες στο',
            'ή κατέβασε το ab app για να αποκτήσεις μία νέα.'
        ]
    },
    lightBox: {
        close: 'Κλείσιμο '
    },
    loading: {
        load: 'Loading ...'
    },
    maps: {
        map: 'AB Kiosk Map'
    },
    introModal: {
        selectProduct: ['Επίλεξε ένα προϊόν από το', 'μώβ ράφι']
    },
    introBody: {
        select: 'Διάλεξε ένα προιόν από το',
        bottomShelf: 'πορτοκαλί ράφι',
        toCreate: 'για να δημιουργήσεις το δικό σου combo και να κερδίσεις',
        points: 'πόντους!'
    },
    introFooter: {
        createYour: 'Φτιάξε το δικό σου',
        combo: 'combo'
    },
    consentModal: {
        wantMore: ' Θέλεις περισσότερα προϊόντα και',
        offers: 'προσφορές με βάση τις αγοραστικές σου συνήθειες;',
        infoOne: 'Επίτρεψέ μας να σε μάθουμε καλύτερα για να σου προσφέρουμε ακόμα περισσότερες προσφορές σχεδιασμένες,',
        infoTwo: 'ειδικά για εσένα, έτσι ώστε να βγαίνεις πολλαπλά κερδισμένος από τις καθημερινές σου αγορές!',
        infoThree: 'Θέλω να λαμβάνω εξατομικευμένες προσφορές βάσει των αγοραστικών μου συνηθειών, στην κάρτα μου AB Plus!',
        approve: 'Αποδέχομαι',
        reject: 'Δεν Αποδέχομαι'
    },
    affinityList: {
        header: 'ΣΥΝΕΡΓΑΣΙΕΣ ΑΒ PLUS',
        subHeader: 'Η ΑΒ Plus σε επιβραβεύει ακόμα περισσότερο!',
        noOffersRightNow: 'Αυτή τη στιγμή δεν υπάρχουν ενεργές συνεργασίες.'
    },
    affinityInsertCode: {
        stepTwo: 'ΒΗΜΑ 2',
        reachedMaxParticipations: 'Έχεις ήδη συμμετάσχει σε αυτήν την ενέργεια',
        insertCode: 'Καταχώρισε τον κωδικό σου',
        wrongCode: ['Ο κωδικός δεν είναι έγκυρος', 'Δοκίμασε ξανά'],
        tooManyTimesWrong: ['Έχεις καταχωρήσει πολλές φορές λάθος κωδικό.', 'Δοκίμασε πάλι αύριο.']
    },
    affinityOffer: {
        gotCode: 'Έχω κωδικό',
        more: 'Μάθε περισσότερα'
    },
    affinityCouponList: {
        selectedCoupons: ['Έχεις επιλέξει', 'προσφορές'],
        remainingCoupons: ['Απομένουν ακόμα', 'πόντοι'],
        topText: ['Κάνε κλικ στην', 'προσφορά', 'για να την ενεργοποιήσεις'],
        bottomTextSmall: 'Όσες προσφορές δεν επιλέξεις θα παραμείνουνε διαθέσιμες μέχρι τη λήξη της προσφοράς',
        couponsPrinted: '%{selectedCoupons} από %{maxCoupons}',
        activeCoupon: 'Ήδη ενεργό',
        nonActiveCoupon: ['ΠΡΟΣ', 'ΕΝΕΡΓΟΠΟΙΗΣΗ'],
        activateCoupons: 'Ενεργοποίηση',
        moreCodesToActivate: 'Έχω κι άλλο κωδικό',
        couponLimit: ['Μπορείς να ενεργοποιήσεις έως', 'προσφορές'],
        infoMessage: ['Κάνε κλικ πάνω στην εικόνα για να την επιλέξεις.']
    },
    inactiveAffinityOffer: {
        inactiveOffer: 'Η καμπάνια που επιλέξατε δεν είναι πλεόν διαθέσιμη.'
    },
    gamePlayAgainModal: {
        text: ['Έχεις', ' ήδη παίξει', 'αυτό το παιχνίδι'],
        youPlayed: 'Έπαιξες στις {n}',
        withoutPoints: 'Μπορείς να παίξεις ξανά χωρίς όφελος σε πόντους',
        playAgain: 'ΠΑΙΞΕ ΞΑΝΑ',
        cancel: 'Ακύρωση',
        redeemed: ['ΕΞΑΡΓΥΡΩΘΗΚΕ ΣΤΙΣ', 'ΚΑΤΑΣΤΗΜΑ'],
        youWon: 'ΚΕΡΔΙΣΕΣ {n} ΠΟΝΤΟΥΣ!',
        getYourPoints: 'Οι πόντοι έχουν ενεργοποιηθεί και θα τους λάβεις πραγματοποιώντας οποιαδηποτε συναλλαγή στα καταστήματα ΑΒ ή στο ΑΒ Εshop έως τις 29/5/22'
    },
    cosmote: {
        OK: 'Το κουπόνι {coupon} ενεργοποιήθηκε επιτυχώς.',
        UNKNOWN_ERROR:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_JSON_FORMAT:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        USER_NOT_FOUND:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_URL_PARAM:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        MISSING_COUPON_DATA:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        COUPON_MISMATCH:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        STORE_NOT_FOUND:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        USER_ALREADY_REGISTERED:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_LOYALTY_CODE:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_RETAILER:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_OR_ALREADY_ADDED_RECEIPT:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_TYPE_OR_ACTION:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        INVALID_COUPON:
            'Μη έγκυρο κουπόνι. Δοκίμασε ξανά με άλλο κωδικό.',
        NOT_ENOUGH_POINTS:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        RULE_ISSUE:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        DISCOUNT_PRICE_MISMATCH:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        TRANSACTION_NOT_FOUND:
            'Προέκυψε σφάλμα κατά την ενεργοποίηση. Παρακαλώ δοκιμάστε αργότερα ή με νέο κωδικό.',
        ALREADY_ACTIVATED: 'Οι προσφορές του κουπονιού έχουν ήδη ενεργοποιηθεί. Δοκίμασε ξανά αν διαθέτεις κι άλλο κωδικό.',
        SOME_COUPONS_ALREADY_ACTIVE:
            'Κάποιες από τις προσφορές του κουπονιού ήταν ήδη ενεργοποιημένες στην κάρτα σου. Οι υπόλοιπες ενεργοποιήθηκαν με επιτυχία.',
        NETWORK_ERROR:
            'Το σύστημα δεν είναι διαθέσιμο αυτή τη στιγμή. Παρακαλούμε δοκιμάστε αργότερα.',
        SOME_COUPONS_FOUND_EXPIRED:
            'Φαίνεται ότι κάποιες από τις προσφορές του κουπονιού έχουν λήξει. Οι υπόλοιπες ενεργοποιήθηκαν με επιτυχία στην κάρτα σου.',
        SOME_COUPONS_NOT_FOUND:
            'Κάποιες από τις προσφορές του κουπονιού δεν βρέθηκαν. Οι υπόλοιπες ενεργοποιήθηκαν με επιτυχία στην κάρτα σου.',
        SOME_COUPONS_FOUND_EXPIRED_AND_SOME_COUPONS_NOT_FOUND:
            'Κάποιες από τις προσφορές του κουπονιού έχουν λήξει και κάποιες δεν βρέθηκαν. Οι υπόλοιπες ενεργοποιήθηκαν με επιτυχία στην κάρτα σου.',
        ALL_ITEMS_FAILED: 'Η ενεργοποίηση των προσφορών του κουπονιού απέτυχε. Δοκίμασε ξανά αν διαθέτεις κι άλλο κωδικό.'
    },
    promoTile: {
        buttonText: '<span>ΚΕΡΔΙΣΕ <strong>ΔΩΡΑ</strong></span>'
    },
    promoView: {
        buttonText: 'Δες τι κέρδισες',
        termsButtonText: 'Όροι Ενέργειας',
        tileIntroText: 'ΣΥΓΚΕΝΤΡΩΣΕΣ',
        tileOutroText: 'ΣΥΜΜΕΤΟΧΕΣ'
    },
    contestTopBar: {
        abCard: 'ΚΩΔΙΚΟΣ ΚΑΡΤΑΣ'
    },
    contestRedeem: {
        transaction: 'Συναλλαγή {date}',
        winNoPrize: 'ΚΕΡΔΙΣΕΣ',
        winPrize: 'ΣΥΓΧΑΡΗΤΗΡΙΑ ΚΕΡΔΙΣΕΣ',
        bonus: 'Κέρδισες bonus πόντους',
        bigGiftParticipation: 'Μία συμμετοχή στην κλήρωση για τα μεγάλα δώρα',
        remainingParticipations: 'Απομένουν <strong>{count}</strong> συμμετοχές',
        nextParticipation: 'Επόμενη συμμετοχή',
        freeProduct: 'ΔΩΡΕΑΝ ΠΡΟΪΟΝ',
        error: 'Oops! Κάτι πήγε στραβά',
        back: 'Επιστροφή',
        noRemainingParticipations: 'Δεν έχεις άλλες διαθέσιμες συμμετοχές',
        tryAgain: 'Παρακαλούμε δοκίμασε ξανά αργότερα'
    },
    contestTerms: {
        back: 'Επιστροφή'
    }
}
